import { useCallback, useEffect, useState } from 'react';
import { postReport } from './reportsApi';

// One report: ONE POST to /api/agent-reports/<path>. The answer is complete or the call fails (the page then says so; it never shows a made-up 0).
//   loading  waiting; no numbers are shown
//   ready    data = the server's answer
//   error    the numbers could not be read; retry() asks again
// `bodyKey` is the body as text, so the call only repeats when the body really changes. Nothing is cached or stored.
export function useReport(path, body, { enabled = true } = {}) {
  const bodyKey = JSON.stringify(body || {});
  const [state, setState] = useState({ status: 'loading', data: null, key: null });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    setState({ status: 'loading', data: null, key: bodyKey });
    (async () => {
      try {
        const res = await postReport(path, JSON.parse(bodyKey));
        const json = await res.json();
        if (cancelled) return;
        if (!res.ok || !json || !json.ok) throw new Error('report');
        setState({ status: 'ready', data: json, key: bodyKey });
      } catch {
        if (!cancelled) setState({ status: 'error', data: null, key: bodyKey });
      }
    })();
    return () => { cancelled = true; };
  }, [path, bodyKey, enabled, attempt]);
  const retry = useCallback(() => setAttempt((a) => a + 1), []);
  return { status: state.key === bodyKey || !enabled ? state.status : 'loading', data: state.key === bodyKey ? state.data : null, retry };
}
